import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaBuilding, FaHashtag } from "react-icons/fa";
import { Printer, Download } from "lucide-react";
import dayjs from "dayjs";

const VoucherAnalysis = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVoucherType, setSelectedVoucherType] = useState("JV");
  const [selectedVoucherDescription, setSelectedVoucherDescription] =
    useState("Voucher");
  const [voucherTypeList, setVoucherTypeList] = useState([]);

  const [deptCode, setDeptCode] = useState("-");
  const [deptDesc, setDeptDesc] = useState("");
  const [deptCodeList, setDeptCodeList] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // new states
  const [voucherNoFrom, setVoucherNoFrom] = useState("");
  const [voucherNoTo, setVoucherNoTo] = useState("");
  const [showRecurring, setShowRecurring] = useState(false);

  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // format: YYYY-MM-DD
  });

  useEffect(() => {
    fetchVoucherTypeList();
    fetchCompanyInfo();
    fetchDeptCodeList();
  }, []);

  const fetchVoucherTypeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/VOUCHER/-/-`;

    try {
      const response = await axios.get(url);
      setVoucherTypeList(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  const fetchDeptCodeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`;

    try {
      const response = await axios.get(apiURL);
      const data = response.data;
      setDeptCodeList(data || []);
    } catch (err) {
      console.error("Error while fetching department list", err);
    }
  };

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/COMPANYINFO/-/-`;
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setStartDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchVoucherAnalysisList = async () => {
    setIsLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    const p2 = voucherNoFrom || "-";
    const p3 = voucherNoTo || "-";
    const p4 = showRecurring ? "RECUR" : "-";
    const p5 = searchTerm || "-";

    const apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherAnalysis/${COMPANY_CODE}/VOUCHER/${startDate}/${endDate}/${deptCode}/${selectedVoucherType}/${p2}/${p3}/${p4}/${p5}`;

    try {
      const response = await axios.get(apiURL);
      const data = response.data;
      console.log("Data of voucher analysis data:", data);
      setFilteredRows(data || []);
    } catch (err) {
      console.error("Error while fetching voucher analysis:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleVoucherTypeChange = (e) => {
    const value = e.target.value;
    const selectedVoucher = voucherTypeList.find(
      (voucher) => voucher.VTYPE === value,
    );

    setSelectedVoucherType(value);
    setSelectedVoucherDescription(selectedVoucher?.VDESCRIPTION || "");
  };

  return (
    <div className="mx-4">
      <h2 className="text-lg text-gray-800 ">Voucher Analysis</h2>

      <div className="bg-white p-4 my-4 rounded shadow">
        <div className="flex justify-between items-center gap-1 ">
          {/* Voucher Type */}
          <div>
            <label className="block text-sm mb-1 flex items-center">
              <FaHashtag className="mr-2 text-gray-600" /> Voucher Type
            </label>
            <select
              value={selectedVoucherType}
              onChange={handleVoucherTypeChange}
              className="w-full px-3 py-2 text-sm border border-gray-300 bg-gray-100 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">All</option>
              {voucherTypeList?.map((voucher) => (
                <option key={voucher.VTYPE} value={voucher.VTYPE}>
                  {voucher.VDESCRIPTION}
                </option>
              ))}
            </select>
          </div>

          {/* Dept Code */}
          <div>
            <label className="block text-sm mb-1 flex items-center">
              <FaBuilding className="mr-2 text-gray-600" /> Dept Code
            </label>
            <select
              onChange={(e) => {
                const selectedDept = deptCodeList.find(
                  (dept) => dept.deptno === e.target.value,
                );
                setDeptCode(e.target.value);
                setDeptDesc(selectedDept ? selectedDept.deptnodesc : "");
              }}
              className="px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
            >
              <option value="all">ALL</option>
              {deptCodeList.map((dept, index) => (
                <option key={index} value={dept.deptno}>
                  {dept.deptnodesc}
                </option>
              ))}
            </select>
          </div>

          {/* Search */}
          <div>
            <input
              type="text"
              placeholder="Search Remarks, Ref, ChqNo etc."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-[300px] mt-5 mr-1 px-3 py-2 shadow-sm text-sm rounded-md bg-gray-100 border border-gray-300 placeholder-gray-400 focus:outline-none focus:border-gray-400"
            />
            <button
              onClick={fetchVoucherAnalysisList}
              className="bg-blue-500 shadow rounded py-2 px-3 text-xs text-white font-semibold hover:bg-blue-700"
            >
              Apply
            </button>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 items-end justify-end">
            <button className="mt-5 flex items-center gap-2 bg-violet-500 text-white font-medium px-4 py-1.5 rounded-lg shadow hover:bg-violet-600 text-sm">
              <Printer className="w-4 h-4" />
              Voucher Print
            </button>
            <button className="mt-5 flex items-center gap-2 bg-teal-600 text-white font-medium px-4 py-1.5 rounded-lg shadow hover:bg-teal-700 text-sm">
              <Printer className="w-4 h-4" />
              Print
            </button>
            <button className="mt-5 flex items-center gap-2 bg-cyan-600 text-white font-medium px-4 py-1.5 rounded-lg shadow hover:bg-cyan-700 text-sm">
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>

        {/* Voucher No and Recurring */}
        <div className="flex justify-between items-center gap-4 mt-8">
          <div className="flex justify-start items-center gap-4 ">
            {/* Start Date */}
            <div className="flex-1  ">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Start Date
              </label>
              <input
                //   disabled={disableGenerate}
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={`
        w-full px-3 py-2 text-sm border border-gray-300 rounded-md 
        bg-gray-100 text-gray-800 placeholder-gray-400
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        disabled:opacity-60 disabled:cursor-not-allowed
        transition-all duration-200
      `}
              />
            </div>

            {/* End Date */}
            <div className="flex-1 ">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                End Date
              </label>
              <input
                //   disabled={disableGenerate}
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                // min={jvRecurringStartDate} // Optional: Prevent end < start
                className={`
        w-full px-3 py-2 text-sm border border-gray-300 rounded-md 
        bg-gray-100 text-gray-800 placeholder-gray-400
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        disabled:opacity-60 disabled:cursor-not-allowed
        transition-all duration-200
      `}
              />
            </div>
          </div>

          <div className="flex justify-start items-center gap-4 ">
            <div>
              <label className="block text-sm mb-1">Voucher No (From)</label>
              <input
                type="text"
                placeholder="Enter start number"
                value={voucherNoFrom}
                onChange={(e) => setVoucherNoFrom(e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Voucher No (To)</label>
              <input
                type="text"
                placeholder="Enter end number"
                value={voucherNoTo}
                onChange={(e) => setVoucherNoTo(e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
          </div>
          <div className="flex items-center gap-3 mt-6">
            <label className="text-sm ">Show Recurring</label>
            <label className="relative inline-block w-[3.5em] h-[2em]">
              <input
                type="checkbox"
                className="peer sr-only"
                checked={showRecurring}
                onChange={(e) => setShowRecurring(e.target.checked)}
              />
              <span
                className={`
        absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
        after:content-[''] after:absolute after:top-[4px] after:left-[4px]
        after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
        after:transition-all after:duration-300 after:ease-in-out
        after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
        peer-checked:bg-blue-500
        peer-checked:after:translate-x-[1.5em]
        peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
        peer-active:after:w-[3em]
        peer-checked:peer-active:after:translate-x-[0.5em]
      `}
              ></span>
            </label>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4 max-h-[60vh]">
        <table className="min-w-full bg-white border border-gray-200 text-sm shadow-sm">
          <thead className="bg-gray-100 sticky top-0 z-20">
            <tr>
              {[
                "Dept No",
                "JV Type",
                "Type No",
                "JV Date",
                "Account",
                "Account Name",
                "Reference",
                "Description",
                "Debit",
                "Credit",
                "Currency",
                "Amount",
                "User Name",
                "Salesperson",
                "Group",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-1 font-normal text-gray-700 border text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filteredRows.length > 0 ? (
              filteredRows.map((rec, index) => (
                <tr
                  key={index}
                  className={`hover:bg-blue-50 border ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 py-2 border text-xs">{rec.DEPTNO}</td>
                  <td className="px-4 py-2 border text-xs">
                    {rec.JVTYPE?.trim()}
                  </td>
                  <td className="px-4 py-2 border text-xs">{rec["TYPE NO"]}</td>
                  <td className="px-4 py-2 border text-xs text-center">
                    {rec.JVDATE
                      ? new Date(rec.JVDATE).toLocaleDateString("en-GB")
                      : "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs">{rec.ACCOUNT}</td>
                  <td className="px-4 py-2 border text-xs">
                    {rec.ACCOUNT_NAME}
                  </td>
                  <td className="px-4 py-2 border text-xs">{rec.REF || "-"}</td>
                  <td className="px-4 py-2 border text-xs">
                    {rec.DESCRIPTION || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.DEBIT?.toFixed(2)}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.CREDIT?.toFixed(2)}
                  </td>
                  <td className="px-4 py-2 border text-xs">{rec.FC}</td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.CURAMOUNT?.toFixed(2)}
                  </td>
                  <td className="px-4 py-2 border text-xs">
                    {rec["USER NAME"]}
                  </td>
                  <td className="px-4 py-2 border text-xs">
                    {rec.SALESPERSON || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs">{rec.GRP}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={16} className="text-center py-6 text-gray-500">
                  {isLoading ? "Loading Data..." : "No Records Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VoucherAnalysis;
